// Filename: gani_web.js
// Timestamp: 2018.12.09-00:12:32 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gninit_run0,
  gninit_run1
} from './gninit.js'

import {
  gnfps_getfpsobj,
  gnfps_rafstart
} from './gnfps.js'

import {
  gngraphNodeDFSFind as graphNodeDFSFind
} from './gngraph.js'

import {
  gnnodeosMetaGet,
  gnnodeosxOnSubj,
  gnnodeosHydrateDFS,
  gnnodeosxAttachDFSChilds,
  gnnodeosRootxAttachDFS,
  gnnodeosRootNSCacheOnFrameKeysCall
} from './gnnodeos.js'

import patch from './gnpatch.js'

import {
  gnrenderPath as renderPath,
  gnrenderPathDiff as renderPathDiff
} from './gnrender.js'

import {
  gnreport_getdelayunitarr,
  gnreportRender as reportRender
} from './gnreport.js'

import {
  gnpublish_vtree,
  gnpublish_domgraph,
  gnpublish_graphsubj,
  gnpublish_persistgraph
} from './gnpublish.js'

import {
  gnevdelegate_dispatchresize,
  gnevdelegate_listenwindow,
  gnevdelegate_listenclick,
  gnevdelegate_listen
} from './gnevdelegate.js'

import {
  gnaccSubj as accSubj
} from './gnacc.js'

import {
  gnpathdef_prefixresolverootspec as pathdefPrefixResolveRootSpec
} from './gnpathdef.js'

import {
  gnerrCfgProbeLocaleEnvRequiredWeb as errCfgProbeLocaleEnvRequiredWeb
} from './gnerr.js'

import {
  gnenumKEY as KEY,
  gnenumNSSUBJ as NSSUBJ,
  gnenumCFGWEBFPMS as CFGWEBFPMS,
  gnenumLOGREPORTS as LOGREPORTS
} from './gnenum.js'

const gnweb_dispatchresize = gnevdelegate_dispatchresize

const gnweb_delaypopulated = async (ss, cfg, gr, nddelay, rep) => {
  let res  = await gnnodeosHydrateDFS(ss, cfg, gr, nddelay, rep)
  gr = res[0]
  nddelay = res[1]

  const nodekey = nddelay.get(KEY)
  const valobj = accSubj.get(nddelay)

  res = await patch(ss, cfg, gr, [[nodekey, NSSUBJ, valobj]])
  gr = res[0]
  rep = res[1]

  return [gr, rep]
}

const gnweb_renderprogressive = async (ss, cfg, gr, delaykeyarr, rep) => {
  const delaykey = delaykeyarr[0]
  let res, nddelay = delaykey && gr.get(delaykey)

  if (!delaykey) {
    return [gr, rep]
  }

  res = await gnweb_delaypopulated(ss, cfg, gr, nddelay, rep)
  gr = res[0]
  rep = res[1]

  res = await gnpublish_domgraph(ss, cfg, gr)
  gr = res[0]

  gnpublish_persistgraph(cfg, gr)
  cfg.graph = gr

  return gnweb_renderprogressive(ss, cfg, gr, delaykeyarr.slice(1), rep)
}

const gnweb_updatepagemeta = (ss, cfg, subj, pnodearr) => (
  cfg.dom.window.document.title =
    cfg.pagemetaget(ss, cfg, subj, pnodearr).title)

const gnweb_win_render = async (ss, cfg, gr, path) => {
  const renderid = Number(++cfg.lastrenderid)
  const iscontinuefn = () => cfg.lastrenderid === renderid

  ss.requrl = path

  let res, pnodearr, objstack, rootnode, vtree, report

  res = await renderPathDiff(ss, cfg, gr, path, ss.objstack, (
    async grpartial => {
      // why not 'reactively' reconstruct this portion of graph
      // by defining relationshiop on vnode?
      //
      // allows path permissions to be controlled in centralised location
      // makes the data value here available to rest of graph construction
      // and publishes any resultant side-effect patches to document
      // graph is incomplete, so 'false' prevents graph from being persisted
      // and erroneously reused by render calls from different stack
      let res = await gnpublish_graphsubj(ss, cfg, grpartial,
        [['/dataenv', NSSUBJ, { requrl: path }]], false)
      const gr = res[0]
      const rep = res[1]

      return [gr, rep]
    }), iscontinuefn)

  gr = res[0]
  pnodearr = res[1]
  objstack = res[2]
  rootnode = res[3]
  vtree = res[4]
  report = res[5]

  if (!iscontinuefn) return null

  ss.objstack = objstack

  const nd = graphNodeDFSFind(ss, cfg, gr, rootnode, (ss, cfg, gr, nd) => (
    gnnodeosMetaGet(nd)
  ))

  gnweb_updatepagemeta(ss, cfg, nd ? accSubj.get(nd) : {}, pnodearr)

  if (cfg.logger.levels[LOGREPORTS])
    cfg.logger.log(reportRender(report))

  gnpublish_vtree(ss, cfg, gr, vtree, cfg.dom)

  gr = gnnodeosRootxAttachDFS(ss, cfg, gr)
  cfg.graph = gr

  return gr
}

const gnwebprobelocaleenv = (sess, cfg) => {
  const manifestlocales = cfg.manifest.locales // comma-separated list
  const manifestlocaleslist = manifestlocales.split(',')
  if (manifestlocaleslist.length === 1) {
    return manifestlocaleslist[0]
  }

  throw errCfgProbeLocaleEnvRequiredWeb(cfg)
}

const gnweb_init = async (globalcfg, envcfg, dom = {}) => {
  const win = dom.window || window
  const doc = win.document
  const winlocation = win.location
  const cfgseed = await gninit_run0(globalcfg, {
    // attach dynamic-render behaviour to local links?
    islocallinkdynamic: false,
    probelocaleenv: gnwebprobelocaleenv,
    ...envcfg,
    pagespecfromisopath: envcfg.pagespecfromisopath
      || (async (sess, cfg, isopath) => {
        // "$ROOTSPECS/spec/manifest.json" -> "/spec/manifest.json"
        const isopathenv = pathdefPrefixResolveRootSpec(isopath, cfg.prefixdir)
        if (cfg.speccache[isopathenv])
          return cfg.speccache[isopathenv]

        const res = await win.fetch(isopathenv).then(async res => ({
          body: await res.json().catch(() => null),
          status: res.status
        }))

        if (res.body)
          cfg.speccache[isopathenv] = res.body

        return res.body
      })
  })
  let res, gr, report, cfg = await gninit_run1(cfgseed, {
    requrl: winlocation.pathname,
    token: '1111' // could be a cookie or session value
  }, win)

  const ss = cfg.ss
  const path = cfg.issinglepage
    ? '/'
    : winlocation.pathname

  // not sure about this scenario. old, inherited scenario
  // consider removing error handling

  res = await renderPath(ss, cfg, path)
  gr = res[0]
  const objstack = res[2]
  // const rootnode = res[3]
  const vtree = res[4]
  report = res[5]

  if (cfg.logger.levels[LOGREPORTS])
    cfg.logger.log(reportRender(report))

  win.gcfg = cfg
  win.gsess = ss

  ss.objstack = objstack

  if (cfg.cfgenv.islocallinkdynamic) {
    cfg.dom.window.addEventListener('popstate', () => {
      // console.log(
      //   `location: ${document.location}`,
      //   `state: ${JSON.stringify(event.state)}`)
      // gnweb_win_render(ss, cfg, cfg.graph, path, hash)
      cfg.dom.window.location.reload()
    })
  }

  gnpublish_vtree(ss, cfg, gr, vtree, dom)
  gr = gnnodeosRootxAttachDFS(ss, cfg, gr)
  cfg.graph = gr

  // gnevdelegate_listenwindow(sess, cfg, win, dom)
  gnevdelegate_listenwindow(ss, cfg, dom)
  gnevdelegate_listen(ss, cfg, doc.body)

  gnevdelegate_listenclick(ss, cfg, doc.body, (ev, linkdetail, nodedisp) => {
    const path = linkdetail.pathname
    const hash = linkdetail.linkhash

    if (cfg.cfgenv.islocallinkdynamic) {
      ev.preventDefault()

      // if (hash) {
      //   cfg.dom.window.location.hash = hash
      // }
      cfg.dom.window.history.pushState({}, '', path)
      gnweb_win_render(ss, cfg, cfg.graph, path).then(() => {
        const targetElem = hash
          && cfg.dom.window.document.getElementById(hash)
          || cfg.dom.window.document.body

        if (targetElem.scrollIntoView) {
          targetElem.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          })
        }
      }).catch(() => {
        cfg.dom.window.location.reload()
      })
    } else {
      nodedisp()
    }
  })

  if (cfg.cfgenv[CFGWEBFPMS]) {
    cfg.fpsobj = gnfps_getfpsobj(cfg.cfgenv[CFGWEBFPMS])
    cfg = gnfps_rafstart(cfg, cfg.fpsobj.mspf, dom, () => {
      gnnodeosRootNSCacheOnFrameKeysCall(ss, cfg, cfg.graph)
    })
  }

  res = await gnweb_renderprogressive(
    ss, cfg, gr, gnreport_getdelayunitarr(report), report)
  gr = res[0]
  report = res[1]
  //, (e, gr, rep) => {
  report.replacearr.map(key => (
    gnnodeosxAttachDFSChilds(ss, cfg, gr, gr.get(key))))

  report.patchkeyarr.map(patchkey => (
    gnnodeosxOnSubj(ss, cfg, gr, gr.get(patchkey))))

  return gr
}

export {
  gnweb_dispatchresize,
  gnweb_delaypopulated,
  gnweb_renderprogressive,
  gnweb_updatepagemeta,
  gnweb_win_render,
  gnweb_init
}
